<template>
    <div class="test">        
        <button @click="btn">点击</button>
        <div class="frame-container">          
            <!-- v-html="content_html" -->
            <div :class="['frame-content-' + space]" v-html="content_html"/>
            <!-- <div class="simple">
                <div class="item-head">帧序列:</div>
                <div class="item-info">
                    <span class="number">30</span>
                    <span class="unit">V</span>
                </div>
            </div>
            <div class="complex">
                <div class="item-head">温度传感器:</div>
                <div class="item-info">
                    <div class="item-info-ob">
                        <span class="ob-key">cefsfaf:</span>
                        <span class="ob-value">30</span>
                        <span class="ob-unit">v</span>
                    </div>
                    <div class="item-info-ob">
                        <span class="ob-key">cefsfaf:</span>
                        <span class="ob-value">30</span>
                        <span class="ob-unit">v</span>
                    </div>
                    <div class="item-info-ob">
                        <span class="ob-key">cefsfaf:</span>
                        <span class="ob-value">30</span>
                        <span class="ob-unit">v</span>
                    </div>
                </div>
            </div> -->

            <!-- <div class="frame-container">
                <div 
                    :class="['collapser', collapse ? 'collapse' : '']"
                    @click="collapse = !collapse"
                >
                    <i class="icon el-icon-caret-right" />
                </div>
                <div :class="['frame-content', 'frame-content-90', collapse ? 'collapse': '']">
                    <div class="item-head">[上报]</div>
                    <div class="item-info simple">
                        <div class="key">kds:</div>
                        <div class="value">fsafsaf</div>
                    </div>
                    <div class="item-info complex">
                        <div class="key">kds:</div>
                        <div class="value">
                            <div class="item-info simple">
                                <div class="key">kds:</div>
                                <div class="value">fsafsaf</div>
                            </div>
                            <div class="item-info simple">
                                <div class="key">kds:</div>
                                <div class="value">fsafsaf</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
// import { hexToArrayBuffer, } from '../core/js/utils'
import { crc16 } from "../core/bkv/parse";
import BKV from "../core/bkv/bkv";
import { t } from "../core/i18n/index";

function arrayBufferToHex(buffer) {
    let hex = '';
    for (let i = 0; i < buffer.length; i++) {
        let h = '00' + buffer[i].toString(16);
        hex += h.substr(-2);
    }
    // console.log("hex", hex);
    return hex
}

function hexToArrayBuffer(hex) {
     if (typeof hex !== 'string') {
         return { code: -1, message: 'Expected input to be a string' }
     }

     if ((hex.length % 2) !== 0) {
         return { code: -2, message: 'Expected string to be an even number of characters' }
     }

     let array = new Uint8Array(hex.length / 2);

     for (let i = 0; i < hex.length; i += 2) {
         array[i / 2] = parseInt(hex.substring(i, i + 2), 16)
     }

     return { code: 0, data: array }
 }

function padStart(v, l = 2, c = '0') {
    return v.toString().padStart(l, c)
}

const CONST = {
    // 帧类型
    FRAME_TYPE: {
        '01' : { key: 'frame.type.login',      name: '登录' },
        '02' : { key: 'frame.type.warning',    name: '告警' },
        '03' : { key: 'frame.type.escalation', name: '上报' },
        '04' : { key: 'frame.type.heartbeat',  name: '心跳' },

        '11' : { key: 'frame.type.login_success',   name: '登录成功' },
        '12' : { key: 'frame.type.receive_success', name: '接收成功' },
        '13' : { key: 'frame.type.get_data',        name: '获取数据' },
        '14' : { key: 'frame.type.remote_control',  name: '远程控制' },
    },
    BATTERY_STATUS: [
        // 内部状态 INTERNAL_STATE
        {
            '0': { key: 'frame.device_status.0_0', name: 'USB输出' },
            '1': { key: 'frame.device_status.0_1', name: '尾灯' },
            '2': { key: 'frame.device_status.0_2', name: '充电器识别状态' },
            '3': { key: 'frame.device_status.0_3', name: '充电器连接状态' },
            '4': { key: 'frame.device_status.0_4', name: '预充电路' },
            '5': { key: 'frame.device_status.0_5', name: '预放电路' },
            '6': { key: 'frame.device_status.0_6', name: '放电MOS' },
            '7': { key: 'frame.device_status.0_7', name: '充电MOS' },
        },{
            '7': { key: 'frame.device_status.1_0', name: '电池停止充电状态' },
        },
        // 错误 ERROR
        {
            '0': { key: 'frame.device_status.2_0', name: '保护 IC 出错' },
            '1': { key: 'frame.device_status.2_1', name: '电芯掉线' },
            '2': { key: 'frame.device_status.2_2', name: '电芯不平衡' },
            '3': { key: 'frame.device_status.2_3', name: '计量出错' },
            '4': { key: 'frame.device_status.2_4', name: '记录出错' },
            '5': { key: 'frame.device_status.2_5', name: '时钟出错' },
            '6': { key: 'frame.device_status.2_6', name: '放电 MOS 损坏' },
            '7': { key: 'frame.device_status.2_7', name: '充电 MOS 损坏' },
        },{
            '0': { key: 'frame.device_status.3_0', name: '过充错误' },
            '1': { key: 'frame.device_status.3_1', name: '初级过放' },
            '2': { key: 'frame.device_status.3_2', name: '二级过放错误' },
            '3': { key: 'frame.device_status.3_3', name: '初级过流' },
            '4': { key: 'frame.device_status.3_4', name: '二级过流' },
            '5': { key: 'frame.device_status.3_5', name: '充电过流' },
            '6': { key: 'frame.device_status.3_6', name: '软启动失败' },
            '7': { key: 'frame.device_status.3_7', name: '预充超时警告' },
        },{
            '0': { key: 'frame.device_status.4_0', name: 'MOS 温度传感器故障' },
            '1': { key: 'frame.device_status.4_1', name: '电芯温度传感器故障' },
            '2': { key: 'frame.device_status.4_2', name: '放电过温' },
            '3': { key: 'frame.device_status.4_3', name: '充电过温' },
            '4': { key: 'frame.device_status.4_4', name: '放电欠温' },
            '5': { key: 'frame.device_status.4_5', name: '充电欠温' },
            '6': { key: 'frame.device_status.4_6', name: '放电 MOS 过温' },
            '7': { key: 'frame.device_status.4_7', name: '充电 MOS 过温' },
        },{
            '0': { key: 'frame.device_status.5_0', name: '软启动电路过温' },
            '4': { key: 'frame.device_status.5_1', name: '三级过流' },
            '6': { key: 'frame.device_status.5_2', name: '配置错误' },
        },
        // 告警 ALARM
        {
            '0': { key: 'frame.device_status.6_0', name: '保护 IC 出错' },
            '1': { key: 'frame.device_status.6_1', name: '电芯掉线' },
            '2': { key: 'frame.device_status.6_2', name: '电芯不平衡' },
            '3': { key: 'frame.device_status.6_3', name: '计量出错' },
            '4': { key: 'frame.device_status.6_4', name: '记录出错' },
            '5': { key: 'frame.device_status.6_5', name: '时钟出错' },
            '6': { key: 'frame.device_status.6_6', name: '放电 MOS 损坏' },
            '7': { key: 'frame.device_status.6_7', name: '充电 MOS 损坏' },
        },{
            '0': { key: 'frame.device_status.7_0', name: '过充错误' },
            '1': { key: 'frame.device_status.7_1', name: '初级过放' },
            '2': { key: 'frame.device_status.7_2', name: '二级过放错误' },
            '3': { key: 'frame.device_status.7_3', name: '初级过流' },
            '4': { key: 'frame.device_status.7_4', name: '二级过流' },
            '5': { key: 'frame.device_status.7_5', name: '充电过流' },
            '6': { key: 'frame.device_status.7_6', name: '软启动失败' },
            '7': { key: 'frame.device_status.7_7', name: '预充超时警告' },
        }
    ],
    ERROR_MAP: {
        '0': { key: 'frame.device_status.2_0', name: '保护 IC 出错' },
        '1': { key: 'frame.device_status.2_1', name: '电芯掉线' },
        '2': { key: 'frame.device_status.2_2', name: '电芯不平衡' },
        '3': { key: 'frame.device_status.2_3', name: '计量出错' },
        '4': { key: 'frame.device_status.2_4', name: '记录出错' },
        '5': { key: 'frame.device_status.2_5', name: '时钟出错' },
        '6': { key: 'frame.device_status.2_6', name: '放电 MOS 损坏' },
        '7': { key: 'frame.device_status.2_7', name: '充电 MOS 损坏' },

        '8':  { key: 'frame.device_status.3_0', name: '过充错误' },
        '9':  { key: 'frame.device_status.3_1', name: '初级过放' },
        '10': { key: 'frame.device_status.3_2', name: '二级过放错误' },
        '11': { key: 'frame.device_status.3_3', name: '初级过流' },
        '12': { key: 'frame.device_status.3_4', name: '二级过流' },
        '13': { key: 'frame.device_status.3_5', name: '充电过流' },
        '14': { key: 'frame.device_status.3_6', name: '软启动失败' },
        '15': { key: 'frame.device_status.3_7', name: '预充超时警告' },

        '16': { key: 'frame.device_status.4_0', name: 'MOS 温度传感器故障' },
        '17': { key: 'frame.device_status.4_1', name: '电芯温度传感器故障' },
        '18': { key: 'frame.device_status.4_2', name: '放电过温' },
        '19': { key: 'frame.device_status.4_3', name: '充电过温' },
        '20': { key: 'frame.device_status.4_4', name: '放电欠温' },
        '21': { key: 'frame.device_status.4_5', name: '充电欠温' },
        '22': { key: 'frame.device_status.4_6', name: '放电 MOS 过温' },
        '23': { key: 'frame.device_status.4_7', name: '充电 MOS 过温' },

        '24': { key: 'frame.device_status.5_0', name: '软启动电路过温' },
        '25': { key: '', name: '' },
        '26': { key: '', name: '' },
        '27': { key: '', name: '' },
        '28': { key: 'frame.device_status.5_4', name: '三级过流' },
        '29': { key: '', name: '' },
        '30': { key: 'frame.device_status.5_6', name: '配置错误' },
        '31': { key: '', name: '' },
    }
}
const FILTER_METHODS = {
    timeFilter: (val) => {
        return dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss')
    },
    valueFilter: (val, map, type) => {
        console.log("上行还是下行", map, type);
        let MAP = CONST[map] || {}
        let ITEM = null

        if (type === "0x87") {
            // 上行
            ITEM = MAP[padStart(val)]
            // console.log("上行", padStart(val));
        } else if (type === "0x84") {
            // 下行
            ITEM = MAP[padStart({ v: val, c:'1' })]
            // console.log("下行", padStart({ v: val, c:'1' }));
        }
        // console.log("结果", ITEM);
        return ITEM ? [ITEM] : ''
    },
    countFilter: (val = 0 ,divisor = 100, dp = 2, type = false) => {
        if (val == 0) { return 0 }
        if (type) {
            return parseFloat((val * divisor).toFixed(dp))
        } else {
            return parseFloat((val / divisor).toFixed(dp))
        }
    },
    // BMS时间
    bmsTimeFilter: (v) => {
        console.log("BMS时间", v);
        return `20${padStart(v[0])}-${padStart(v[1])}-${padStart(v[2])} ${padStart(v[3])}:${padStart(v[4])}:${padStart(v[5])}`
    },
    // 温度传感器
    temperatureSensorFilter: (v) => {
        let arr = []
        for (let i = 0; i < CONST['TEMPERATURE_SENSOR_NAME'].length; i++) {
            arr.push({
                name: CONST['TEMPERATURE_SENSOR_NAME'][i],
                key: CONST['TEMPERATURE_SENSOR_NAME'][i],
                content: v[i],
            })
        }
        return arr;
    },
    // 电池版本
    versionFilter: (v) => {
        return [
            {
                name: '软件版本',
                key: 'device.software_version',
                content: `${v[0]}${v[1]}`,
            },{
                name: '硬件版本',
                key: 'device.hardware_version',
                content: `${v[2]}${v[3]}`,
            },{
                name: '固件索引码',
                key: 'device.firmware_index_code',
                content: `${v[4]}${v[5]}${v[6]}${v[7]}`,
            },
        ]
    },
    // 生产时间
    manufactureDateFilter: (v) => {
        return `20${padStart(v[0])}-${padStart(v[1])}-${padStart(v[2])}`
    },
    // 电芯电压
    cellVoltageFilter: (v) => {
        console.log("电芯电压", v);
        let arr = []
        for (let i = 0; i < v.length; i = i + 2) {
            arr.push({ content: `${new DataView(v.slice(i, i+2).buffer).getUint16(0, true)}mV` })
        }
        return arr.map(i => i.content).join(', ');
    },
    // 电池最值记录
    historyFilter: (v) => {
        return [
            {
                name: '最大放电电流',
                key: 'device.maximum_discharge_current',
                content: `${new DataView(v.slice(0,4).buffer).getInt32(0, true)}mAh`
            },{
                name: '最大充电电流',
                key: 'device.maximum_charging_current',
                content: `${new DataView(v.slice(4,8).buffer).getInt32(0, true)}mAh`
            },{
                name: '最大电芯电压',
                key: 'device.maximum_cell_voltage',
                content: `${new DataView(v.slice(8,10).buffer).getUint16(0, true)}mV`
            },{
                name: '最小电芯电压',
                key: 'device.minimum_cell_voltage',
                content: `${new DataView(v.slice(10,12).buffer).getUint16(0, true)}mV`
            },{
                name: '电池包最大温度',
                key: 'device.maximum_battery_pack_temperature',
                content:`${new DataView(v.slice(12,13).buffer).getInt8(0, true)}°`
            },{
                name: '电池包最小温度',
                key: 'device.minimum_battery_pack_temperature',
                content: `${new DataView(v.slice(13,14).buffer).getInt8(0, true)}°`
            },
        ]
    },

    // 错误计数
    errorCountFilter: (v) => {
        const ERROR_MAP = CONST.ERROR_MAP
        let arr = []

        for (let i = 0; i < v.length; i = i+2) {
            let d = ERROR_MAP[(i/2) + '']
            if (d.key) {
                arr.push({
                    ...d,
                    content: `${new DataView(v.slice(i, i+2).buffer).getUint16(0, true)}`,
                })
            }
        }

        return arr
    },
    // 电池状态
    batteryStatusFilter: (v) =>  {
        const BATTERY_STATUS = CONST.BATTERY_STATUS

        function getBit(b,i) { // 获取第i位的bit值 并判断
            let bit = (b >> i) & 0x1;
            return bit !== 0;
        }

        let parts = []
        for (let i = 0; i < BATTERY_STATUS.length; i++) {
            let _v = v[i]
            for (const key in BATTERY_STATUS[i]) {
                if (getBit(_v, parseInt(key))) {
                    parts.push({
                        ...BATTERY_STATUS[i][key],
                    })
                }
            }
        }
        parts.push({ key: 'frame.device_status.8',  name: '电池剩余容量百分比', content: `${v[8]}%` })
        parts.push({ key: 'frame.device_status.9',  name: '电池健康状态百分比', content: `${v[9]}%` })
        parts.push({ key: 'frame.device_status.10', name: '电池包总电压', content: `${new DataView(v.slice(10,14).buffer).getUint32(0, true)}mV` })
        parts.push({ key: 'frame.device_status.14', name: '实时电流', content: `${new DataView(v.slice(14,18).buffer).getUint32(0, true)}mA` })
        parts.push({ key: 'frame.device_status.18', name: '实时电芯最高温度', content: `${v[18]}°` })
        parts.push({ key: 'frame.device_status.19', name: '实时电芯最低温度', content: `${v[19]}°` })
        parts.push({ key: 'frame.device_status.20', name: '实时Mos管温度', content: `${v[20]}°` })
        parts.push({ key: 'frame.device_status.21', name: '其他温度', content: `${v[21]}°` })

        let maximum_charge_current_unit = (v[22] >> 6) & (0xFF >> 6)
        switch (maximum_charge_current_unit) {
            case 0: maximum_charge_current_unit = 0.05; break;
            case 1: maximum_charge_current_unit = 0.1; break;
            case 2: maximum_charge_current_unit = 1; break;
            case 3: maximum_charge_current_unit = 2; break;
        }
        let maximum_charge_current = (v[22] >> 0) & (0xFF >> 2)
        parts.push({ key: 'frame.device_status.22', name: '允许最大充电电流', content: `${maximum_charge_current * maximum_charge_current_unit}A` })

        // byte 23： 放电信息 Discharging message Bit7 ~ Bit0: Reserved
        parts.push({ key: 'frame.device_status.24', name: '电池循环次数', content: `${new DataView(v.slice(24,26).buffer).getUint16(0, true)}` })

        return parts
    },
}

export default {
    components: {},
    props: {},
    data() {
        return {
            collapse: false,
            space: '260011',
            content_html: "",
            CMD_MAP: {
                /**
                * @param(filter) 过滤的方法
                * @param(params) 帧类型: 上报  (value) => 对应的是{ key: "中英文", name: "中文注释" }
                * @param(key) 帧类型  (key) => $t('key') 
                * @param(name) 记录一下中文名称(没用到) 
                */                
                0x01: { cmd: '0x01', type: 'uint8', filter: 'valueFilter', key: 'frame_type', name: "帧类型", params: ['FRAME_TYPE'],},  // 类型数据上报等
                // 0x02: { cmd: '0x02', type: 'number', },
                // 0x03: { cmd: '0x03', type: 'hex', },
                0x04: { cmd: '0x04', type: 'bytes', filter: 'bmsTimeFilter', key: 'bms_time', name: 'BMS时间'},  // BMS时间，年月日时分秒，第一个字节为年份的后两位

                // 低16节电压数据，每节用uint16表示，单位mV
                0x57: { cmd: '0x57', type: 'bytes', filter: 'cellVoltageFilter', key: 'cell_voltage_1', name: '电芯电压 1',},
                // 高16节电压数据，每节用uint16表示，单位mV
                0x58: { cmd: '0x58', type: 'bytes', filter: 'cellVoltageFilter', key: 'cell_voltage_2', name: '电芯电压 2'},
                // 电池最值记录:
                0x59: { cmd: '0x59', type: 'bytes', filter: 'historyFilter', key: 'history', name: '电池最值记录',},

                // 错误计数
                0x60: { cmd: '0x60', type: 'bytes', key: 'system_error_status', name: '错误计数', filter: 'errorCountFilter'},
                // 电池状态
                0x67: { cmd: '0x67', type: 'bytes', key: 'battery_status', name: '电池状态', filter: 'batteryStatusFilter'},
            }
        }
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        btn() { 
            // let hex = "87c403010103080104170b110e04072201571f0d1e0d1e0d1e0d170d180d1b0d1b0d1a0d1c0d1b0d1e0d1e0d1d0d1d0d1b0d2201581d0d1b0d1b0d1f0d1d0d1d0d210d000000000000000000000000000000000000100159f690fefff32700003c0e75083f1442016001000000000000000000000000000000030027002900000000000100360000000000000000000100000000000000000001000000192e000000000000000000001c0167020000000000000064628e2d0100fcffffff1f1f20200000c3001d1c"
            let hex = "f0f100250401010100060102632fdfa303010301120111435752543330303230353237383937372e4e"  // 新协议
            const frameData = this.publishFrame(hex)
            console.log("frameData", frameData.data);

            // this.content_html = this.parsePayload(frameData.data)
        },
        publishFrame(hex) {
            let res = this.runParser2(hex)
            
            if (res.code !== 0) { return res }

            let frame = res.data
            let data = {}

            try {
                let items = frame.items()
                console.log("长度", items.length);
                for(let index = 0; index < items.length; index++) {
                    let item = items[index]
                    let k = item.key();
                    let v = item.value();
                    console.log("每个值的变化k", k, "每个值的变化v", v);
                                        
                    let d = this.CMD_MAP[k] || {cmd : '0x' + (k.toString(16))}
                    let content = ''
                    // console.log("最终获得的数据", d, d.type);
                    
                    try {
                        switch (d.type) {
                            case 'string':
                                content = item.stringValue()
                                break;
                            case 'uint8':
                                content = new DataView(v.buffer).getUint8(0, true)
                                console.log("uint8", content);
                                break;
                            case 'int8':
                                // content = new DataView(v.buffer).getInt8(0, true)
                                break;
                            case 'uint16':
                                // content = new DataView(v.buffer).getUint16(0, true)
                                break;
                            case 'int16':
                                // content = new DataView(v.buffer).getInt16(0, true)
                                break;
                            case 'uint32':
                                // content = new DataView(v.buffer).getUint32(0, true)
                                break;
                            case 'int32':
                                // content = new DataView(v.buffer).getInt32(0, true)
                                break;
                            case 'number':
                                // content = parseInt(arrayBufferToHex(v), 16)
                                break;
                            case 'hex':
                                // content = arrayBufferToHex(v)
                                break;
                            case 'bytes':
                                content = v
                                break;
                            case 'data':
                                // content = bkvUnpack(arrayBufferToHex(v), true)
                                break;
                        }
                        // 过滤一下
                        if (d.filter) {
                            content = FILTER_METHODS[d.filter](content, ...(d.params ? d.params : []), res.type)    
                            console.log(`结果${ d.filter }`, content);
                        }
                    } catch (error) {
                        console.log('publishFrame d:', d, 'value', arrayBufferToHex(v), 'error', error)
                    }        
                    
                    data[k] = {
                        cmd: d.cmd || '',
                        type: d.type || '',
                        name: d.name || '',
                        value: arrayBufferToHex(v),
                        
                        key: d.key ? 'device.'+ d.key : '',
                        unit: d.unit || '',
                        content,
                    }
                }

            } catch(error) {
                console.log('publishFrame error', error);
            }

            return { code: 0, data, type: res.type }
        },
        // BKV 解包
        runParser(hex) {
            let res = hexToArrayBuffer(hex)

            if (res.code !== 0) {
                return res
            }

            let buffer = res.data

            console.log("BKV解包", buffer);

            if (buffer.length < 4) {
                return { code: -3, message: 'Buffer too short' }
            }

            let backHeadIndex = buffer.findIndex((e) => e === 0x87); // 设备返回数据(上行)
            let sendHeadIndex = buffer.findIndex((e) => e === 0x84); // 主机写入数据(下行)

            console.log("上行位置", backHeadIndex);
            console.log("下行位置", sendHeadIndex);

            if (backHeadIndex < 0 || sendHeadIndex < 0) {
                console.log('parser', 'head not exists or tail not exists');
            }

            let headIndex = backHeadIndex >= 0 ? backHeadIndex : sendHeadIndex

            // 帧长是否太短
            let fb = buffer.slice(headIndex);
            if (fb.length < 4) {                
                console.log({ code: -4, message: 'frame length too short' });
                return { code: -4, message: 'frame length too short' }
            }
            console.log("帧长", fb);
            // 帧长是否不匹配
            let length = fb[1];
            console.log("帧长是否不匹配", length);
            if (fb.length < length + 4) {
                console.log({ code: -5, message: 'frame length not match' });
                return { code: -5, message: 'frame length not match' }
            }

            // 检查长度
            console.log("检查长度checksum", fb.slice(1, length + 2), "检查长度calculatedChecksum", fb.slice(length + 2));
            let checksum = new DataView(fb.buffer).getUint16(2 + length, false)
            let calculatedChecksum = crc16(fb.slice(1, length + 2));
            console.log("checksum", checksum, "calculatedChecksum", calculatedChecksum);
            if (checksum !== calculatedChecksum) {
                console.log({ code: -6, message: 'checksum not match' });
                return { code: -6, message: 'checksum not match' }
            }
            
            // const ccc = hexToArrayBuffer("03010103080104170b110e04072201571f0d1e0d1e0d1e0d170d180d1b0d1b0d1a0d1c0d1b0d1e0d1e0d1d0d1d0d1b0d2201581d0d1b0d1b0d1f0d1d0d1d0d210d000000000000000000000000000000000000100159f690fefff32700003c0e75083f1442016001000000000000000000000000000000030027002900000000000100360000000000000000000100000000000000000001000000192e000000000000000000001c0167020000000000000064628e2d0100fcffffff1f1f20200000c300")
            // console.log("测试", ccc);

            // 正式处理BKV数据
            let b = BKV.unpack(fb.slice(2, length + 2))
            if (b.code === 0) {
                let type = null
                if (backHeadIndex >= 0) {
                    type = "0x87"
                } else if (sendHeadIndex >= 0) {
                    type = "0x84"
                }
                return { code: 0, data: b.bkv, type }
            } else {
                return { code: -7, message: 'bkv parse fail' }
            }
        },  
        runParser2(hex) {
            let res = hexToArrayBuffer(hex)            
            if (res.code !== 0) {
                return res
            }

            let buffer = res.data

            console.log("BKV解包", buffer);

            if (buffer.length < 4) {
                return { code: -3, message: 'Buffer too short' }
            }

            let backHeadIndex = buffer.findIndex((e) => e === 0xF0); // 设备返回数据(上行)
            if (buffer.findIndex((e) => e === 0xF1) >= 0) {
                backHeadIndex = buffer.findIndex((e) => e === 0xF1); // 设备返回数据(上行)                
            }
            let sendHeadIndex = buffer.findIndex((e) => e === 0x84); // 主机写入数据(下行)

            console.log("上行位置", backHeadIndex);
            console.log("下行位置", sendHeadIndex);
            
            if (backHeadIndex < 0 || sendHeadIndex < 0) {
                console.log('parser', 'head not exists or tail not exists');
            }
            
            let headIndex = backHeadIndex >= 0 ? backHeadIndex : sendHeadIndex
            
            // 帧长是否太短
            let fb = buffer.slice(0);
            if (fb.length < 4) {                
                console.log({ code: -4, message: 'frame length too short' });
                return { code: -4, message: 'frame length too short' }
            }
            console.log("帧长", fb[backHeadIndex + 1], fb[backHeadIndex + 2]);
            
            // 帧长是否不匹配
            let length = fb[backHeadIndex + 1] + fb[backHeadIndex + 2];
            console.log("帧长是否不匹配", length);            
            if (fb.length < length + 4) {
                console.log({ code: -5, message: 'frame length not match' });
                return { code: -5, message: 'frame length not match' }
            }

            // 检查长度 (数据有误)
            // console.log("检查长度calculatedChecksum", fb.slice(3, length + 2), "检查长度checksum", fb.slice(length + 2));
            // let checksum = new DataView(fb.buffer).getUint16(2 + length, false)
            // let calculatedChecksum = crc16(fb.slice(3, length + 2));
            // console.log("checksum", checksum, "calculatedChecksum", calculatedChecksum);
            // if (checksum !== calculatedChecksum) {
            //     console.log({ code: -6, message: 'checksum not match' });
            //     return { code: -6, message: 'checksum not match' }
            // }
                    
            let b = BKV.unpack(fb.slice(4, length + 2))
            if (b.code === 0) {
                let type = null
                return { code: 0, data: b.bkv }
            } else {
                return { code: -7, message: 'bkv parse fail' }
            }
        },  
        parsePayload(data) {
            let items = [];

            let addHead = function (content, key) {
                items.push(`<div class="item-head ${key}">[${content}]</div>`);
            }

            let addSimpleItem = function (key, value, unit) {              
                items.push(`<div class="simple">
                    <div class="item-head">${key}:</div>
                    <div class="item-info">
                        <span class="number">${value}</span>
                        <span class="unit">${unit}</span>
                    </div>
                </div>`)
            }

            let addComplexItem = function (key, arr) {

                items.push(`<div class="complex">
                                <div class="item-head">${key}:</div>
                                <div class="item-info">`)

               for (const item of arr) {
                    items.push(`<div class="item-info-ob">
                            <span class="ob-key">${ item.key ? t(item.key) + (item.content ? ':' : '') : '' }</span>
                            <span class="ob-value">${ item.content || ''}</span>
                            <span class="ob-unit">${ item.unit || ''}</span>
                        </div>`)
               }

               items.push(`</div></div>`);
            }
            
            // 测试用来截取用的
            // const keys = Object.keys(data);
            // const result = keys.reduce((acc, key, index) => {
            //     if (index < 5) {
            //         acc[key] = data[key];
            //     }
            //     return acc;
            // }, {});

            for (let key in data) {
                try {
                    let item = data[key];
                    if (typeof item.content === 'object') {
                        addComplexItem(t(item.key), item.content)
                    } else {
                        addSimpleItem(t(item.key), item.content, item.unit)
                    }
                } catch (error) {
                    console.log('parsePayload for error:', error)
                }
            }
            
            console.log("返回的v-html", items);

            return items.join('')
        }      
    },
}

/*
区别
0x12  10010    => 第1位
0x34  110100   => 第2位
0x56  1010110  => 第3位
0x78  1111000  => 第4位

大端字节序(false)
    最高位的字节位于偏移量位置, 而最低位的字节位于偏移量加 3 的位置
    读取的 4 个字节分别为0x12、0x34、0x56和0x78，
    则将它们组合为 32 位整数时的二进制形式为：00010010 00110100 01010110 01111000
    解析出来 305419896

小端字节序(true)
    读取的 4 个字节分别为0x12、0x34、0x56和0x78，
    则将它们组合为 32 位整数时的二进制形式为：01111000 01010110 00110100 00010010
    解析出来 2018915346
*/

</script>

<style lang='scss'>
.frame-content-260011 {
    width: 100%;
    display: flex;
    flex-direction: column;
    color:#8E949C;    
    // 简单的
    
    .simple {
        display: flex;
        // flex-wrap: wrap;
        .item-head {
            margin-right: 10px;
            white-space: nowrap;
        }
        .item-info {
            .number {
    
            }
            .unit {
    
            }
        }
    }
    // 复杂的
    .complex {
        display: flex;
        // flex-wrap: wrap;
        .item-head {
            margin-right: 10px;     
            white-space: nowrap;      
        }
        .item-info {
            display: flex;
            flex-wrap: wrap;
            .item-info-ob {
                width: 200px;
                .ob-key {}
                .ob-value {}
                .ob-unit {}
            }
        }
    }
}

.frame-container {
    position: relative;
    width: 100%;
    .collapser {
        position: absolute;
        top: 0;
        left: 0;
        width: 32px;
        height: 23px;
        display: flex;
        align-items: center;
        .icon {
            font-size: 10px;
            transition: transform 0.3s ease;
            transform: rotate(90deg);
        }

        &.collapse {
            .icon {
                transform: rotate(0);
            }
        }
    }
}

.frame-content-90 {   
    overflow: hidden;

    .item-head {
        height: 23px;
        padding-left: 20px;
    }
    .item-info {        
        display: flex;
        .key {
            color:#8E949C;
            white-space: nowrap;
            margin-right: 8px;
        }
        .value {
            word-break: normal; 
        }

        &.simple {
            .key {}
            .value {}
        }

        &.complex {
            .key {}
            .value {
                display: flex;
                flex-wrap: wrap;
                .item-info {
                    width: 260px;
                }
            }
        }
    }

    &.collapse {
        .item-info {
            height: 0;
        }
    }
}
</style>

